import { z } from '@harvestiq/zod';
import { dbCampaignSchema } from './db-campaigns';
import { dbCampaignRecipientsSchema } from '../campaign-recipients/db-campaign-recipients';

export const campaignSchema = dbCampaignSchema.extend({
  recipients: dbCampaignRecipientsSchema.array(),
});
export type Campaign = z.infer<typeof campaignSchema>;
